var mirrorwater;
(function($) {
  "use strict";
  mirrorwater = (function() {
    return {
      init: function() {
        // Header
        this.announcement();
        this.currencySwitcher();
        this.fixedHeader();
        // this.account();
        this.search();
        this.headerCart();
        this.recentlyViewedCart();
        this.mobileMenu();
        this.mirrorWaterFM();

        // Home
        this.homeHero();
        this.homeProducts();
        this.homeFaq();
        this.homeCommunity();

        // Collection
        this.collection();

        // Product
        this.productForm();
        this.productMobileImages();
        this.productTabs();
        this.relatedProducts();
        this.productMobileFeatures();
        this.productStickyBar();

        // Pages
        this.contactPage();
        this.blogPage();
        this.ingredientsPage();
        this.accountPage();

        // Utilities
        this.matchHeight();
        this.aos();
        this.video();
        this.accordion();
      },
      
      // Header
      announcement: function() {
        if(localStorage.getItem('country') !== null && localStorage.getItem('timezone') !== null) {
          var country = 'row'; 
          var timezone = localStorage.getItem('timezone');
          if(timezone.indexOf("Europe") >= 0) {
            country = 'eu';
          }
          if(localStorage.getItem('country') == 'GB') {
            country = 'uk';
          }
          if(localStorage.getItem('country') == 'US') {
            country = 'us';
          }
          if(localStorage.getItem('country') == 'AU') {
            country = 'au';
          }
          $(".js-announcement-item:not(.show-for-" + country + ")").remove();
          $('.js-announcement-carousel').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
            vertical: true,
            autoplay: true,
            autoplaySpeed: 3000,
          });
        } else {
          $.get("https://ipinfo.io", function(response) {
            var country = 'row';
            if(response.timezone.indexOf("Europe") >= 0) {
              country = 'eu';
            }
            if(response.country == 'GB') {
              country = 'uk';
            }
            if(response.country == 'US') {
              country = 'us';
            }
            if(response.country == 'AU') {
              country = 'au';
            }
            localStorage.setItem('country', response.country);
            localStorage.setItem('timezone', response.timezone);
            $(".js-announcement-item:not(.show-for-" + country + ")").remove();
            $('.js-announcement-carousel').slick({
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              vertical: true,
              autoplay: true,
              autoplaySpeed: 3000,
            });
          }, "jsonp");
        }
      },

      currencySwitcher: function () {
        $(".js-currency-item").on("click", function () {
          var currencyId = $(this).attr("data-id");
          var option = $("#currency").find('option[data-id="' + currencyId + '"]');
          option.attr("selected", "true");
          $("#currency-form-select").submit();
          return false;
        });
        $(".js-currency-mobile-item").on("click", function () {
          var currencyId = $(this).attr("data-id");
          var option = $("#mobile-currency").find('option[data-id="' + currencyId + '"]');
          option.attr("selected", "true");
          $("#currency-mobile-form-select").submit();
          return false;
        });
        $("#currency-mobile-form-select").click(function () {
          $(".js-mobile-currency-content").addClass("active");
          return false;
        });
        $(document).on('click', function (e) {
          if($(e.target).closest("#currency-mobile-form-select").length === 0) {
            $(".js-mobile-currency-content").removeClass("active");
          }
        });
      },

      fixedHeader: function() {
        var scrollTop = $(window).scrollTop();
        if(scrollTop > 0) { 
          $(".js-header").addClass("fixed-header");
        } else {
          $(".js-header").removeClass("fixed-header");
        }
        $(window).scroll(function() {
          var scrollTop = $(window).scrollTop();
          if(scrollTop > 0) { 
            $(".js-header").addClass("fixed-header");
          } else {
            $(".js-header").removeClass("fixed-header");
          }
        });
      },

      account: function() {
        $(".js-toggle-account").click(function () {
          if($(".js-login").hasClass("active")) {
            $(".js-login").removeClass("show");
            setTimeout(function () {
              $(".js-login").toggleClass("active");
            }, 350);
            $("body").removeClass("disable-wishlist");
          } else {
            $(".js-login").addClass("active");
            setTimeout(function () {
              $(".js-login").addClass("show");
            }, 20);
            $("body").addClass("disable-wishlist");
          }
          return false;
        });
        $(".js-go-to-canvas-forgotten-password").click(function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login-canvas").click(function () {
          $(".js-login-canvas-login").removeClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").addClass("d-none")
          return false;
        });
        $(".js-go-to-canvas-register").click(function () {
          $(".js-login-canvas-login").addClass("d-none");
          $(".js-login-canvas-forgotten-password").addClass("d-none");
          $(".js-login-canvas-register").removeClass("d-none")
          return false;
        });
        $(".js-go-to-forgotten-password").click(function () {
          $(".js-login-login").addClass("d-none");
          $(".js-login-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login").click(function () {
          $(".js-login-login").removeClass("d-none");
          $(".js-login-forgotten-password").addClass("d-none");
          return false;
        });
        $(".js-go-to-forgotten-password-2").click(function () {
          $(".js-login").addClass("d-none");
          $(".js-forgotten-password").removeClass("d-none");
          return false;
        });
        $(".js-back-to-login-2").click(function () {
          $(".js-login").removeClass("d-none");
          $(".js-forgotten-password").addClass("d-none");
          return false;
        });
      },

      search: function() {
        $(".js-toggle-predictive-search").click(function () {
          if($(".js-predictive-search").hasClass("active")) {
            $(".js-predictive-search").removeClass("show");
            setTimeout(function () {
              $(".js-predictive-search").toggleClass("active");
            }, 350);
            $("body").removeClass("disable-wishlist");
          } else {
            $(".js-predictive-search").addClass("active");
            setTimeout(function () {
              $(".js-predictive-search").addClass("show");
            }, 20);
            $("body").addClass("disable-wishlist");
          }
          return false;
        });
      },

      headerCart: function() {
        $(".js-open-cart").click(function () {
          $(".js-canvas-cart").addClass("active");
          setTimeout(function () {
            $(".js-canvas-cart").addClass("show");
          }, 20);
          $("body").addClass("disable-wishlist");
          return false;
        });
        $("body").on("click", ".js-close-canvas-cart", function() {
          if(!$(".js-cart-note").hasClass("active")) {
            $(".js-canvas-cart").removeClass("show");
            setTimeout(function () {
              $(".js-canvas-cart").toggleClass("active");
            }, 350);
            $("body").removeClass("disable-wishlist");
          }
          return false;
        });
        $("body").on("click", ".js-change-quantity a, .js-change-quantity-2", function() {
          $(this).parent().addClass("loading");
          var variantId = parseInt($(this).parent().attr("data-variant-id"));
          var quantity = parseInt($(this).parent().attr("data-quantity"));
          var that = $(this).parent().parent();
          $(that).find(".js-quantity-minus").attr("data-quantity", quantity - 1);
          $(that).find(".js-quantity-plus").attr("data-quantity", quantity + 1);
          $(that).closest(".js-cart-item").css("height", $(that).closest(".js-cart-item").outerHeight());
          $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: variantId, quantity: quantity },
            success: function(response) {
              $(".js-change-quantity").removeClass("loading");
              $(".js-subtotal-price").html(Shopify.formatMoney(response.total_price));
              var newPrice = response.total_price;
              if(quantity < 1) {
                $(that).closest(".js-cart-item").addClass("hide-item");
                setTimeout(function () {
                  $(that).closest(".js-cart-item").addClass("hidden");
                  if(newPrice == 0) {
                    $(".js-cart-content").addClass("canvas-cart__empty");
                    $(".js-canvas-cart-suggestions").removeClass("active");
                  }
                }, 300);
              } else {
                $(that).find(".js-quantity-field-input").val(quantity);
              }
              if($(".js-free-delivery").length > 0) {
                var width = 0;
                var limit = parseInt($(".js-free-delivery").attr("data-limit"));
                var price = Shopify.formatMoney(0);
                if(response.total_price >= limit) {
                  width = 100;
                  $(".js-free-delivery").addClass("active");
                } else {
                  $(".js-free-delivery").removeClass("active");
                  if(response.total_price > 0) {
                    width = (response.total_price/limit)*100;
                    price = Shopify.formatMoney(limit - response.total_price);
                    $(".js-cart-spend-more-money").html($(".js-free-delivery").attr("data-spend-more-text").replace("price", price));
                  }
                }
                $(".js-free-delivery-bar").css("width", width + "%");
              }
              $('.js-cart-counter').html(response.item_count).attr("data-counter", response.item_count);
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              $(".js-change-quantity").removeClass("loading");
            }
          });
          return false;
        });
        $("body").on("click", ".js-cart-payment", function () {
          $(".js-cart-checkout").click();
        });
        $("body").on("click", ".js-cart-checkout", function () {
            if(localStorage.getItem("cartNote") != '' && localStorage.getItem("cartNote") != null) {
              var note = localStorage.getItem("cartNote");
               $(".js-cart-note").html(note);
            } else {
            $(".js-cart-note").html(null);
          }
        });
        Shopify.Products.showRecentlyViewed( { howManyToShow: 12 } );
        setTimeout(function () {
          $(".js-cart-product").each(function () {
            var productId = $(this).attr("data-product-id");
            if($(".js-cart-product[data-product-id='" + productId + "']").length > 1) {
              $(this).remove();
            }
          });
        }, 1000);
        $(".js-cart-gift-bag").click(function () {
          if($(this).hasClass("active")) {

            var id = $(this).attr('data-product-id');
            quantity = 0;
            
            $.ajax({
            type: 'POST',
            url: '/cart/change.js',
            dataType: 'json',
            data: { id: id, quantity: quantity },
            success: function(response) {
              $(".js-subtotal-price").html(Shopify.formatMoney(response.total_price));
              var newPrice = response.total_price;
              if(quantity < 1) {
                $(".js-cart-item[data-variant-id='43810394472611']").addClass("hide-item");
                setTimeout(function () {
                  $(".js-cart-item[data-variant-id='43810394472611']").addClass("hidden");
                  if(newPrice == 0) {
                    $(".js-cart-content").addClass("canvas-cart__empty");
                    $(".js-canvas-cart-suggestions").removeClass("active");
                  }
                }, 300);
              } else {
                return false;
              }
              if($(".js-free-delivery").length > 0) {
                var width = 0;
                var limit = parseInt($(".js-free-delivery").attr("data-limit"));
                var price = Shopify.formatMoney(0);
                if(response.total_price >= limit) {
                  width = 100;
                  $(".js-free-delivery").addClass("active");
                } else {
                  $(".js-free-delivery").removeClass("active");
                  if(response.total_price > 0) {
                    width = (response.total_price/limit)*100;
                    price = Shopify.formatMoney(limit - response.total_price);
                    $(".js-cart-spend-more-money").html($(".js-free-delivery").attr("data-spend-more-text").replace("price", price));
                  }
                }
                $(".js-free-delivery-bar").css("width", width + "%");
              }
              $('.js-cart-counter').html(response.item_count).attr("data-counter", response.item_count);

            $('.js-cart-gift-bag').removeClass("active");
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
              $(".js-change-quantity").removeClass("loading");
            }
          });
            
          } else {

            var id = $(this).attr('data-product-id');
            var quantity = 1;

            $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, },
            success: function(response) {
              // Add product cart
              var variant_id = response.variant_id;
              if($(".js-cart-item[data-variant-id='" + variant_id + "']:not(.hidden)").length > 0) {
                var quantity = response.quantity;
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-minus").attr("data-quantity", quantity - 1);
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-plus").attr("data-quantity", quantity + 1);
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-field-input").val(quantity);
              } else {
                var options = '';
                if(response.options_with_values.length > 0) {
                  $.each(response.options_with_values, function( key, value ) {
                    if(value.name != 'Title') {
                      options += '<div class="cart-item__option">' + value.value + '</div>';
                    }
                  });
                }
                if(localStorage.getItem("preorder") == 'true') {
                  options += '<div class="cart-item__option">Pre-order</div>';
                }
                var quantity_minus = response.quantity - 1;
                var quantity_plus = response.quantity + 1;
                var item = '<li class="cart-item d-flex first-show js-cart-item d-none" data-variant-id="' + response.variant_id + '">';
                item += '<p class="cart-item__image">';
                item += '<a href="' + response.url + '">';
                item += '<img alt="Image" data-sizes="auto" data-srcset="' + response.image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload lazy-effect">';
                item += '</a>';
                item += '</p>';
                item += '<div class="cart-item__right">';
                item += '<div class="cart-item__top-right">';
                item += '<div class="cart-item__price">' + Shopify.formatMoney(response.price) + '</div>';
                item += '<div class="cart-item__details">';
                item += '<a href="' + response.url + '" class="cart-item__title">' + response.product_title + '</a>';
                item += '</div>' + options + '</div>';
                item += '<div class="cart-item__quantity-and-delete d-flex align-items-center">';
                item += '<div class="cart-item__quantity">';
                item += '<div class="cart-product__quantity-field">';
                item += '<div class="quantity-field__minus js-change-quantity js-quantity-minus" data-variant-id="' + response.variant_id + '" data-quantity="' + quantity_minus + '"><a href="#">-</a></div>';
                item += '<input type="text" value="' + response.quantity + '" class="quantity-field__input js-quantity-field-input">';
                item += '<div class="quantity-field__plus js-change-quantity js-quantity-plus" data-variant-id="' + response.variant_id + '" data-quantity="' + quantity_plus + '"><a href="#">+</a></div>';
                item += '</div>';
                item += '</div>';
                item += '<p class="cart-item__delete" data-variant-id="' + response.variant_id + '" data-quantity="0">';
                item += '<a href="#" class="js-change-quantity-2">Remove</a>';
                item += '</p>';
                item += '</div>';
                item += '</div>';
                item += '</li>';
                $(".js-cart-items").append(item);
                setTimeout(function () {
                  $(".js-cart-item").removeClass("first-show");
                }, 100);
              }

              // Get cart
              jQuery.getJSON('/cart.js', function(cart) {
                $(".js-change-quantity").removeClass("loading");
                $(".js-subtotal-price").html(Shopify.formatMoney(cart.total_price));
                var newPrice = cart.total_price;
                if($(".js-free-delivery").length > 0) {
                  var width = 0;
                  var limit = parseInt($(".js-free-delivery").attr("data-limit"));
                  var price = Shopify.formatMoney(0);
                  if(cart.total_price >= limit) {
                    width = 100;
                    $(".js-free-delivery").addClass("active");
                  } else {
                    $(".js-free-delivery").removeClass("active");
                    if(cart.total_price > 0) {
                      width = (cart.total_price/limit)*100;
                      price = Shopify.formatMoney(limit - cart.total_price);
                      $(".js-cart-spend-more-money").html($(".js-free-delivery").attr("data-spend-more-text").replace("price", price));
                    }
                  }
                  $(".js-free-delivery-bar").css("width", width + "%");
                }

                $(".js-cart-content").removeClass("canvas-cart__empty");

                $('.js-cart-counter').html(cart.item_count).attr("data-counter", cart.item_count);
                $(".js-canvas-cart").addClass("active");
                setTimeout(function () {
                  $(".js-canvas-cart").addClass("show");
                }, 20);
                $("body").addClass("disable-wishlist");
                localStorage.setItem("preorder", "false");
              });
              
            $('.js-cart-gift-bag').addClass("active");
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);
            }
          });      
          }
          return false;
        });
  
        $(".js-cart-order-note").click(function () {
          $(".js-cart-note").addClass("active");
          setTimeout(function () {
            $(".js-cart-note").addClass("show");
          }, 20);
          return false;
        });
        $(".js-cancel-cart-note").click(function () {
          $(".js-cart-note").removeClass("show");
          setTimeout(function () {
            $(".js-cart-note").removeClass("active");
          }, 350);
          return false;
        });
        $(".js-confirm-cart-note").click(function () {
          localStorage.setItem("cartNote", $(".js-cart-note-editable").val());
          $(".js-cart-note").removeClass("show");
          setTimeout(function () {
            $(".js-cart-note").removeClass("active");
          }, 350);
          if(localStorage.getItem("cartNote") != '' && localStorage.getItem("cartNote") != null) {
            $(".js-cart-order-note").addClass("active");
          } else {
            $(".js-cart-order-note").removeClass("active");
          }
          return false;
        });
        $(".js-cart-note-editable").val(localStorage.getItem("cartNote"));
        if(localStorage.getItem("cartNote") != '' && localStorage.getItem("cartNote") != null) {
          $(".js-cart-order-note").addClass("active");
        }
      },

      recentlyViewedCart: function() {
        setTimeout(function () {
          $(".js-recently-viewed-content").html($(".js-recently-viewed").html());
          $(".js-get-preorder-text").each(function () {
            var url = $(this).attr("data-product-url");
            var that = $(this);
            if(localStorage.getItem(url) != 'false' && localStorage.getItem(url) != 'true') {
              $.get(url, function( data ) {
                if($(data).find(".js-product .js-add-to-cart").attr("data-current-variant-pre-order") == 'true') {
                  $(that).html("+ Pre-order");
                  localStorage.setItem(url, 'true');
                } else {
                  localStorage.setItem(url, 'false');
                } 
              });
            } else {
              if(localStorage.getItem(url) == 'true') {
                $(that).html("+ Pre-order");
              }
            }
          })
        }, 3000);
      },

      mobileMenu: function() {
        $(".js-open-mobile-menu").click(function () {
          $(this).toggleClass("active");
          $(".js-mobile-menu").toggleClass("active");
          $(".js-header").toggleClass("active-mobile-menu");
          var minHeight = $(window).outerHeight() - 96;
          $(".js-mobile-menu-d-flex").css("min-height", minHeight + "px");
          $("body").toggleClass("disable-wishlist");
          return false;
        });
      },

      mirrorWaterFM: function() {
        $(".js-open-mirror-water-fm, .js-close-mirror-water-fm").click(function () {
          $(".js-mirror-water-fm").toggleClass("active");
          return false;
        });
      },

      // Home
      homeHero: function() {
        var i = 1;
        $(".js-hero-products").each(function () {
          $(this).addClass("js-hero-products-" + i);
          const splide = new Splide('.js-hero-products-' + i, {
            type   : 'slide',
            autoplay: true,
            drag   : false,
            gap    :  '9px',
            perPage: 1,
            drag: 'free'
          });
          splide.mount();
          splide.on('moved', function (newIndex, prevIndex, destIndex) {
            $(".js-current-hero-slide").html(newIndex + 1);
          });
          i++;
        });
        $(".js-all-hero-slides").html($(".js-hero-product").length);
      },

      homeProducts: function() {
        var i = 1;
        $(".js-home-products").each(function () {
          $(this).addClass("js-home-products-" + i);
          const splide = new Splide('.js-home-products-' + i, {
            type   : 'slide',
            drag   : false,
            gap    :  '9px',
            perPage: 4,
            drag: 'free',
            breakpoints : {
              767: {
                perPage: 1
              },
              991: {
                perPage: 2
              },
              1198:{
                perPage: 3
              }
            }
          });
          splide.mount();
          i++;
        });
        $(".js-change-product-tab").click(function () {
          $(".js-change-product-tab").removeClass("active");
          $(this).addClass("active");
          var index = $(this).attr("data-index");
          $(".js-home-product-tab").removeClass("active");
          $(".js-home-product-tab[data-index='" + index + "']").addClass("active");          
          return false;
        });
      },

      homeFaq: function() {
        $(".js-faq-question").hover(function () {
          if($(window).outerWidth() > 991) {
            var index = $(this).attr("data-index");
            $(".js-faq-background-item").removeClass("active");
            $(".js-faq-background-item[data-index='" + index + "']").addClass("active");
          }
        });
      },

      homeCommunity: function() {
        if($(".js-community-blocks").length > 0) {
          const splide = new Splide('.js-community-blocks', {
            type   : 'slide',
            drag   : false,
            gap    :  '12px',
            perPage: 3,
            drag: 'free',
            breakpoints : {
              767: {
                perPage: 1,
              },
              991: {
                perPage: 2,
              },
              1198:{
                perPage: 2,
              }
            }
          });
          splide.mount();
        }
      },

      // Collection
      collection: function() {
        $("body").on("click", ".js-collection-next-page", function () {
          var href = $(this).attr("href");
          $(".js-collection-next-page").html($(".js-collection-next-page").attr("data-loading-text"));
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $(".js-collection-action").remove();
            $('.js-collection-row').append($(data).find('.js-collection-row').html());
          });
          return false;
        });
      },

      // Product
      productForm: function() {
        function variants(productId) {
          var data = JSON.parse(document.getElementById('ProductJson' + productId + '').innerHTML);
          var selectCallback = function(variant, selector) {
            var that = $(".js-product[data-product-id='" + productId + "'], .js-sticky-bar");
            if (variant) {
              if (variant.available) {
                $(that).find(".js-product-add-to-cart").removeClass("d-none");
                $(that).find(".js-product-out-of-stock").addClass("d-none");
                $(".js-sticky-add-to-cart").removeClass("d-none");
              } else {
                $(that).find(".js-product-add-to-cart").addClass("d-none");
                $(that).find(".js-product-out-of-stock").removeClass("d-none");
                $(".js-sticky-add-to-cart").addClass("d-none");
              }
              if(variant.compare_at_price > variant.price) {
                $(that).find(".js-price-old").removeClass("d-none").html(Shopify.formatMoney(variant.compare_at_price));
                $(that).find(".js-price-new").html(Shopify.formatMoney(variant.price));
              } else {
                $(that).find(".js-price-old").addClass("d-none")
                $(that).find(".js-price-new").html(Shopify.formatMoney(variant.price));
              }
              var preOrderText = $(that).find(".js-add-to-cart").attr("data-add-to-bag-text");
              if($(that).find(".js-add-to-cart").attr("data-preorder") == "true" && $(that).find('select[name="id"] option:selected').attr("data-continue-selling-when-out-of-stock") == "true" && parseInt($(that).find('select[name="id"] option:selected').attr("data-quantity")) < 1) {
                var preOrderText = $(that).find(".js-add-to-cart").attr("data-preorder-text");
              }
              $(that).find(".js-add-to-cart").html(preOrderText);
            } else {
              $(that).find(".js-product-add-to-cart").addClass("d-none");
              $(that).find(".js-product-out-of-stock").removeClass("d-none");
              $(".js-sticky-add-to-cart").addClass("d-none");
            }
          }
          jQuery(function($) {
            if($("#product-select-" + productId + "").length > 0) {
              new Shopify.OptionSelectors("product-select-" + productId + "", { product: data , onVariantSelected: selectCallback, enableHistoryState: true });
            }
          });
        }

        $(".js-product").each(function () {
          variants($(this).attr("data-product-id"));
        });

        if(parseInt($(".js-current-variant").find("option:selected").attr("data-quantity")) < 5 && parseInt($(".js-current-variant").find("option:selected").attr("data-quantity")) > 0) {
          $(".js-last-few-remaining").removeClass("d-none");
        } else {
          $(".js-last-few-remaining").addClass("d-none");
        }

        $(".js-product-size").click(function () {
          var option = $(this).parent().parent().attr("data-option");
          var value = $(this).attr("data-value");
          var productId = $(this).attr("data-product-id");
          $(".js-product[data-product-id='" + productId + "'] #product-variants select[data-option='" + option + "']").val(value).change();
          $(".js-product ul[data-option='" + option + "'] .js-product-size, .js-sticky-bar ul[data-option='" + option + "'] .js-product-size").parent().removeClass("active");
          $(".js-product ul[data-option='" + option + "'] .js-product-size[data-value='" + value + "'], .js-sticky-bar ul[data-option='" + option + "'] .js-product-size[data-value='" + value + "']").parent().addClass("active");
          if(parseInt($(".js-current-variant").find("option:selected").attr("data-quantity")) < 5 && parseInt($(".js-current-variant").find("option:selected").attr("data-quantity")) > 0) {
            $(".js-last-few-remaining").removeClass("d-none");
          } else {
            $(".js-last-few-remaining").addClass("d-none");
          }
          return false;
        });

        $("body").on("click", ".js-product-out-of-stock a", function() {
          $(".klaviyo-bis-trigger")[0].click();
          return false;
        });

        $("body").on("click", ".js-add-to-cart, .js-add-variant-to-bag", function () {
          var preOrderText = $(this).html();
          if(preOrderText == 'Pre-order' || preOrderText == '+ Pre-order') {
            localStorage.setItem("preorder", "true");
          }
          if(!$(this).hasClass("js-add-variant-to-bag")) {
            $(this).html($(this).attr("data-adding-text")).addClass("loading");
          } else {
            $(this).addClass("loading");
          }
          if($(this).hasClass("variant") || $(this).hasClass("js-add-variant-to-bag")) {
            var quantity = 1;
            var id = $(this).attr("data-variant-id");
            var properties = {};
          } else {
            var productId = $(this).attr("data-product-id");
            var quantity = $(".js-product[data-product-id='" + productId + "'] .js-quantity-field").val();
            if(isNaN(quantity)) { quantity = 1; }
            var id = $(".js-product[data-product-id='" + productId + "'] #product-select-" + productId + "").val();
            var properties = {};
          }
          var that = $(this);
    
          $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: { id: id, quantity: quantity, properties: properties },
            success: function(response) {
              // Add product cart
              var variant_id = response.variant_id;
              if($(".js-cart-item[data-variant-id='" + variant_id + "']:not(.hidden)").length > 0) {
                var quantity = response.quantity;
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-minus").attr("data-quantity", quantity - 1);
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-plus").attr("data-quantity", quantity + 1);
                $(".js-cart-item[data-variant-id='" + variant_id + "']").find(".js-quantity-field-input").val(quantity);
              } else {
                var options = '';
                if(response.options_with_values.length > 0) {
                  $.each(response.options_with_values, function( key, value ) {
                    if(value.name != 'Title') {
                      options += '<div class="cart-item__option">' + value.value + '</div>';
                    }
                  });
                }
                if(localStorage.getItem("preorder") == 'true') {
                  options += '<div class="cart-item__option">Pre-order</div>';
                }
                var quantity_minus = response.quantity - 1;
                var quantity_plus = response.quantity + 1;
                var item = '<li class="cart-item d-flex first-show js-cart-item" data-variant-id="' + response.variant_id + '">';
                item += '<p class="cart-item__image">';
                item += '<a href="' + response.url + '">';
                item += '<img alt="Image" data-sizes="auto" data-srcset="' + response.image + ' 400w" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==" class="lazyload lazy-effect">';
                item += '</a>';
                item += '</p>';
                item += '<div class="cart-item__right">';
                item += '<div class="cart-item__top-right">';
                item += '<div class="cart-item__price">' + Shopify.formatMoney(response.price) + '</div>';
                item += '<div class="cart-item__details">';
                item += '<a href="' + response.url + '" class="cart-item__title">' + response.product_title + '</a>';
                item += '</div>' + options + '</div>';
                item += '<div class="cart-item__quantity-and-delete d-flex align-items-center">';
                item += '<div class="cart-item__quantity">';
                item += '<div class="cart-product__quantity-field">';
                item += '<div class="quantity-field__minus js-change-quantity js-quantity-minus" data-variant-id="' + response.variant_id + '" data-quantity="' + quantity_minus + '"><a href="#">-</a></div>';
                item += '<input type="text" value="' + response.quantity + '" class="quantity-field__input js-quantity-field-input">';
                item += '<div class="quantity-field__plus js-change-quantity js-quantity-plus" data-variant-id="' + response.variant_id + '" data-quantity="' + quantity_plus + '"><a href="#">+</a></div>';
                item += '</div>';
                item += '</div>';
                item += '<p class="cart-item__delete" data-variant-id="' + response.variant_id + '" data-quantity="0">';
                item += '<a href="#" class="js-change-quantity-2">Remove</a>';
                item += '</p>';
                item += '</div>';
                item += '</div>';
                item += '</li>';
                $(".js-cart-items").append(item);
                setTimeout(function () {
                  $(".js-cart-item").removeClass("first-show");
                }, 100);
              }

              // Get cart
              jQuery.getJSON('/cart.js', function(cart) {
                $(".js-change-quantity").removeClass("loading");
                $(".js-subtotal-price").html(Shopify.formatMoney(cart.total_price));
                var newPrice = cart.total_price;
                if($(".js-free-delivery").length > 0) {
                  var width = 0;
                  var limit = parseInt($(".js-free-delivery").attr("data-limit"));
                  var price = Shopify.formatMoney(0);
                  if(cart.total_price >= limit) {
                    width = 100;
                    $(".js-free-delivery").addClass("active");
                  } else {
                    $(".js-free-delivery").removeClass("active");
                    if(cart.total_price > 0) {
                      width = (cart.total_price/limit)*100;
                      price = Shopify.formatMoney(limit - cart.total_price);
                      $(".js-cart-spend-more-money").html($(".js-free-delivery").attr("data-spend-more-text").replace("price", price));
                    }
                  }
                  $(".js-free-delivery-bar").css("width", width + "%");
                }
                $(".js-cart-content").removeClass("canvas-cart__empty");

                $(that).html(preOrderText).removeClass("loading");
                $('.js-cart-counter').html(cart.item_count).attr("data-counter", cart.item_count);
                $(".js-canvas-cart").addClass("active");
                setTimeout(function () {
                  $(".js-canvas-cart").addClass("show");
                }, 20);
                $("body").addClass("disable-wishlist");
                localStorage.setItem("preorder", "false");
              });
            },
            error: function(response) {
              var errorMessage = response.responseJSON
                ? response.responseJSON.description
                : theme.strings.cartError;
              alert(errorMessage);

            }
          });
          return false;
        });
      },

      productMobileImages: function() {
        var i = 1;
        $(".js-product-mobile-images").each(function () {
          $(this).addClass("js-product-mobile-images-" + i);
          const splide = new Splide('.js-product-mobile-images-' + i, {
            type   : 'slide',
            drag   : false,
            gap    :  '9px',
            perPage: 1,
            drag: 'free'
          });
          splide.mount();
          i++;
        });
      },
      
      productTabs: function() {
        $(".js-open-product-page-tab").click(function () {
          var id = $(this).attr("data-id");
          $(".js-product-page-tab").removeClass("active").removeClass("show");
          $(".js-product-page-tab[data-id='" + id + "']").addClass("active");
          setTimeout(function () {
            $(".js-product-page-tab[data-id='" + id + "']").addClass("show");
          }, 50);
          return false;
        });
        $(".js-close-product-page-tab").click(function () {
          $(".js-product-page-tab").removeClass("show");
          setTimeout(function () {
            $(".js-product-page-tab").removeClass("active");
          }, 350);
          return false;
        });
      },

      productRelatedProducts: function() {
        var i = 1;
        $(".js-related-products").each(function () {
          $(this).addClass("js-related-products-" + i);
          const splide = new Splide('.js-related-products-' + i, {
            type   : 'slide',
            drag   : false,
            gap    :  '9px',
            perPage: 4,
            drag: 'free',
            breakpoints : {
              767: {
                perPage: 1
              },
              991: {
                perPage: 2
              },
              1198:{
                perPage: 3
              }
            }
          });
          splide.mount();
          i++;
        });
      },

      relatedProducts: function() {
        if($(".product-recommendations").length > 0) {
          loadRelatedProducts();
        }
        function loadRelatedProducts() {
          var productRecommendationsSection = document.querySelector(".product-recommendations");
          if (productRecommendationsSection === null) { return; }
          var productId = $(".product-recommendations").attr("data-product-id");
          var limit = $(".product-recommendations").attr("data-limit");
          var requestUrl = "/recommendations/products?section_id=main-product-related&limit="+limit+"&product_id="+productId;
          var request = new XMLHttpRequest();
          request.open("GET", requestUrl);
          request.onload = function() {
            if (request.status >= 200 && request.status < 300) {
              var container = document.createElement("div");
              container.innerHTML = request.response;
              productRecommendationsSection.parentElement.innerHTML = container.querySelector(".product-recommendations").innerHTML;
              mirrorwater.productRelatedProducts();
            }
          };
          request.send();
        }
      },

      productMobileFeatures: function() {
        var i = 1;
        $(".js-product-mobile-features").each(function () {
          $(this).addClass("js-product-mobile-features-" + i);
          const splide = new Splide('.js-product-mobile-features-' + i, {
            type   : 'loop',
            drag   : false,
            gap    :  '1px',
            perPage: 1,
            drag: true,
            autoplay: true,
            loop: true
          });
          splide.mount();
          i++;
        });
      },

      productStickyBar: function() {
        if($('form[data-type="add-to-cart-form"]').length > 0) {
          $(window).scroll(function() {
            var scrollTop = $(window).scrollTop();
            if(scrollTop > $('form[data-type="add-to-cart-form"]').offset().top + $('form[data-type="add-to-cart-form"]').outerHeight()) { 
              $(".js-sticky-bar, .js-mobile-sticky-bar").addClass("active");
            } else {
              $(".js-sticky-bar, .js-mobile-sticky-bar").removeClass("active");
            }
          });
        }
      },

      // Pages
      contactPage: function() {
        $(".js-contact-submit").click(function () {
          var message = $(".js-contact-body").val() + "\n\n";
          message += "Order number: " + $(".js-contact-order-number").val();
          $(".js-contact-body").val(message);
        });
      },

      blogPage: function() {
        $("body").on("click", ".js-blog-next-page", function () {
          var href = $(this).attr("data-href");
          $(".js-blog-next-page").html($(".js-blog-next-page").attr("data-loading-text"));
          $.ajax({
            url: href,
            type: 'GET'
          }).done(function(data) {
            $(".js-blog-action").remove();
            $('.js-blog-row').append($(data).find('.js-blog-row').html());
          })
          return false;
        });
      },

      ingredientsPage: function() {
        $(".js-ingredient-letter").each(function () {
          var letter = $(this).attr("data-letter");
          if($(".js-ingredients[data-letter='" + letter + "']").length < 1) {
            $(this).addClass("unactive");
          }
        });
        $(".js-ingredient-letter").click(function () {
          var letter = $(this).attr("data-letter");
          if($(".js-ingredients[data-letter='" + letter + "']").length > 0) {
            var positionTop = parseInt($(".js-ingredients[data-letter='" + letter + "']").offset().top - 80);
            $('body, html').animate({ scrollTop: positionTop, }, 0);
          }
          return false;
        });
      },

      accountPage: function() {
        $(".js-show-all-order-images").click(function (e) {
          $(this).closest(".js-order").addClass("active");
          e.preventDefault();
          return false;
        });
      },

      // Utilities
      matchHeight: function() {
        $('.js-match-height').matchHeight();
      },

      aos: function() {
        AOS.init();
        setInterval(function () {
          $(".aos-init.aos-animate").addClass("animation-done");
        }, 300);
      },

      video: function() {
        $('.js-youtube-video').youtube_background();
        $('.js-vimeo-video').vimeo_player();
        if($('.js-video').length > 0) {
          $(".js-video").each(function () {
            this.controls = false;
            $(this).get(0).play();
          });
        }
        if($('.js-video-2').length > 0) {
          $(".js-video-2").each(function () {
            this.controls = false;
          });
          setInterval(function () {
            $(".js-video-2").each(function () {
              if($(this).closest(".aos-init").hasClass("animation-done")) {
                $(this).get(0).play();
                $(this).removeClass("js-video-2");
              }
            });
          }, 1000);
        }
        $(".js-main-product-image video").each(function () {
          this.controls = false;
          $(this).get(0).play();
        });
      },

      accordion: function() {
        $(".js-accordion").each(function () {
          if(!$(this).hasClass("done")) {
            $(this).find(".js-accordion-title").click(function() {
              $(this).parent().parent().find(".js-accordion").removeClass("current");
              $(this).parent().toggleClass("active").addClass("current");
              $(this).parent().parent().find(".js-accordion:not(.current).active .js-accordion-content").slideToggle(500);
              $(this).parent().parent().find(".js-accordion:not(.current).active").removeClass("active");
              $(this).parent().find(".js-accordion-content").slideToggle(500);
            });
            if($(this).hasClass("active")) {
              $(this).find(".js-accordion-content").slideToggle(500);
            }
          }
          $(this).addClass("done");
        });
      }
    }
  })();
})(jQuery);

$(document).ready(function() {
  mirrorwater.init();
});

if (window.Shopify.designMode) {
  jQuery(document)
    .on('shopify:section:load', function() {
      mirrorwater.init();
    }).on('shopify:section:unload', function() {
      mirrorwater.init();
    }).on('shopify:section:select', function() {
      mirrorwater.init();
    }).on('shopify:section:deselect', function() {
      mirrorwater.init();
    }).on('shopify:block:select', function() {
      mirrorwater.init();
    }).on('shopify:block:deselect', function() {
      mirrorwater.init();
    });
}